var map = {
	"./AI.png": 1264,
	"./Analytics.png": 6580,
	"./BygSystems_FullLogo_Dark.png": 7486,
	"./BygSystems_MarkLogo_JadeGreen.png": 3987,
	"./Ellipse.png": 7290,
	"./Eloquent-i.svg": 3469,
	"./Eloquent-i_ipad.gif": 8455,
	"./Horizon.png": 4005,
	"./ISO-27001-2022-grey.png": 8891,
	"./ISO-27001-2022-grey_no background1.png": 2748,
	"./ISO27001-Blue.png": 8884,
	"./ISO27001.png": 8677,
	"./Line.png": 5452,
	"./Line2.png": 9972,
	"./MainSectionStars.png": 7901,
	"./StarSplash.png": 3951,
	"./VectorStars 1.png": 2477,
	"./analytics-mockup.png": 5818,
	"./background-block.png": 2158,
	"./background-block2.jpg": 2186,
	"./background-block2.png": 4574,
	"./bg-animation.png": 3446,
	"./bg-circle-wide.png": 4152,
	"./demo-main-banner.png": 2422,
	"./eloquenti-logo.png": 2342,
	"./graph.png": 388,
	"./icon1.png": 3628,
	"./icon2.png": 1735,
	"./icon3.png": 2510,
	"./ipad.png": 1994,
	"./ipad2.png": 1074,
	"./loading-feedback.svg": 8504,
	"./logo-white.png": 8587,
	"./logo.png": 9419,
	"./person1.png": 8240,
	"./person2.png": 6923,
	"./person3.png": 7922,
	"./phone-1.png": 1386,
	"./phone-2.png": 369,
	"./phone-3.png": 2104,
	"./phone-left.png": 1000,
	"./phone-middle.png": 8676,
	"./phone-right.png": 4189,
	"./play.png": 7276,
	"./purple-star.png": 9763,
	"./purple-star.svg": 6827,
	"./shooting-star-down.png": 9247,
	"./shooting-star-page-split.png": 9765,
	"./shooting-star.png": 8828,
	"./star.png": 6154,
	"./stars-bottom.png": 4251,
	"./stars.png": 2363,
	"./wave.png": 3185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7636;